import React from "react";

const CheckoutFooter: React.FC = () => {
  return (
    <div className="w-full bg-[rgb(255,228,228)] pb-8 sm:pb-10 lg:pb-10 p-3 sm:p-4 mt-4 sm:mt-5">
      <div className="element-wrapper">
        <div className="img el-554854 mt-6 sm:mt-8 md:mt-10 text-center">
          <img
            crossOrigin="anonymous"
            src="//img.funnelish.com/41178/302481/1710818540-Magique%20%281%29.png"
            data-srcset="//img.funnelish.com/41178/302481/1710818540-Magique%20%281%29.png 1x"
            alt="Magique Logo"
            data-sizes="auto"
            data-src="//img.funnelish.com/41178/302481/1710818540-Magique%20%281%29.png"
            className="w-24 sm:w-32 md:w-[150px] h-auto lazyautosizes ls-is-cached lazyloaded inline-block"
            sizes="150px"
            srcSet="//img.funnelish.com/41178/302481/1710818540-Magique%20%281%29.png 1x"
          />
        </div>
      </div>
      <div className="element-wrapper">
        <div className="font-sans leading-relaxed mt-2 mb-3 sm:mb-4 p-2 sm:p-3 text-center text-[11px] sm:text-xs md:text-sm lg:text-base">
          <div className="paragraph-inner">
            <p className="text-center">
              <span className="text-gray-800">
                Magique™ - Copyright 2026 - All Rights Reserved.
              </span>
            </p>
            <p className="text-center">
              <span className="text-gray-800 bg-transparent">
                <a
                  className="external"
                  href="https://trymagique.com/pages/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>{" "}
                -{" "}
                <a
                  className="external"
                  href="https://trymagique.com/pages/terms-of-service"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>{" "}
                -{" "}
                <a
                  className="external"
                  href="https://trymagique.com/pages/returns-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Returns Policy
                </a>{" "}
                -{" "}
                <a
                  className="external"
                  href="https://trymagique.com/pages/shipping-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shipping Policy
                </a>
              </span>
            </p>
            <p className="text-center">
              <span className="text-gray-800 bg-transparent">
                support@trymagique.com
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutFooter;
